import StopsRow from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['stops'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { stops } = props.selectors.getJourneyFields(state, props.journeyId, fields);
    return {
      stops,
    };
  })
);

export default enhance(StopsRow);
